import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Resumen de marketing',
  tiles: {
    followers: 'Seguidores',
    delivered_messages: 'Mensajes entregados',
    open_rate: 'Tasa de apertura',
    click_rate: 'Tasa de clics',
    spam_report_rate: 'Tasa de reportes de spam',
    unsubscribe_rate: 'Tasa de cancelación de suscripción',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Fuente de suscripción',
      count: 'Cantidad',
      percentage: 'Porcentaje',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Plantilla',
      delivered: 'Entregado',
      open_rate: 'Tasa de apertura',
      click_rate: 'Tasa de clics',
      spam_report_rate: 'Tasa de reportes de spam',
      unsubscribe_rate: 'Tasa de cancelación de suscripción',
    },
  },
  labels: {
    no_data: 'Sin datos',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
